import React from 'react';
import Hidden, { HiddenProps } from '@material-ui/core/Hidden';

const HiddenNext: React.FC<HiddenProps> = props => <Hidden {...props} />;

export default HiddenNext;
